import { render, staticRenderFns } from "./vehicle.parameters.metodica.vue?vue&type=template&id=56cb1bbf&"
import script from "./vehicle.parameters.metodica.vue?vue&type=script&lang=js&"
export * from "./vehicle.parameters.metodica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports